// extracted by mini-css-extract-plugin
export var brand = "_1k-8";
export var compact = "_1k-5";
export var extraSmall = "_1k-6";
export var icon = "_1k-0";
export var large = "_1k-3";
export var light = "_1k-1";
export var medium = "_1k-4";
export var outline = "_1k-a";
export var primaryDark = "_1k-9";
export var primaryLight = "_1k-7";
export var primaryModern = "_1k-b";
export var success = "_1k-2";